import { action } from "typesafe-actions";
import ActionTypes from "../constants";

export const helpMePopupLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "help_me_popup_loaded",
    okind: "auto_proposal",
    edata: {
      product_state: "Callback Requested",
      ls: true,
      lob: "direct",
      ...edata
    },
    odata: {
      ...odata
    }
  });

export const mobileNumberEntered = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "mobile_number_entered",
    okind: "auto_proposal",
    edata: {
      ls: true,
      lob: "direct",
      ...edata
    },
    odata: {
      ...odata
    }
  });

export const helpMeFormSubmitted = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "help_me_form_submitted",
    okind: "auto_proposal",
    edata: {
      product_state: "Callback Requested",
      ls: true,
      lob: "direct",
      ...edata
    },
    odata: {
      ...odata
    }
  });

export const chatbotClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "chatbot_clicked",
    okind: "ackore_proposal",
    edata: {
      ls: true,
      lob: "direct",
      ...edata
    },
    odata: {
      ...odata
    }
  });

export const helpMeFloaterClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "help_me_floater_clicked",
    okind: "auto_proposal",
    edata: {
      product_state: "Callback Requested",
      ls: true,
      lob: "direct",
      ...edata
    },
    odata: {
      ...odata
    }
  });
